export default __webpack_public_path__ + "static/media/redCard.e8d8ae6d.png";